import type { AccountTabScreenId } from '../../components/Account/Account.types';

export type AuthRedirectTarget =
  | 'home'
  | 'locations'
  | 'bag'
  | 'add-gift-card'
  | 'gift-cards'
  | 'gift-redeem'
  | 'payments'
  | 'scan-at-checkout'
  | 'forgot-to-scan'
  | 'receipt'
  | 'receipt-claim'
  | AccountTabScreenId;
